import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MeasuringDevicesComponent} from './measuring-devices/measuring-devices.component';
import {RouterModule} from '@angular/router';
import {EditMeasuringDevicesComponent} from './edit-measuring-devices/edit-measuring-devices.component';
import {ShowMeasuringDevicesComponent} from './show-measuring-devices/show-measuring-devices.component';
import {NxCardModule} from '@allianz/ng-aquila/card';
import {NxIconModule} from '@allianz/ng-aquila/icon';
import {ComponentsModule} from '../../components/components.module';
import {NxHeadlineModule} from '@allianz/ng-aquila/headline';
import {NxGridModule} from '@allianz/ng-aquila/grid';
import {NxButtonModule} from '@allianz/ng-aquila/button';
import {NxFormfieldModule} from '@allianz/ng-aquila/formfield';
import {NxInputModule} from '@allianz/ng-aquila/input';
import {FormsModule} from '@angular/forms';
import {NxSwitcherModule} from "@allianz/ng-aquila/switcher";
import {NxDropdownModule} from "@allianz/ng-aquila/dropdown";
import {TextFieldModule} from "@angular/cdk/text-field";
import {NxToolbarModule} from "@allianz/ng-aquila/toolbar";
import {NxImageModule} from "@allianz/ng-aquila/image";
import {NxMessageModule} from "@allianz/ng-aquila/message";
import {IrfComponentsModule} from "common";
import {NxDatefieldModule} from "@allianz/ng-aquila/datefield";
import {NxModalModule} from "@allianz/ng-aquila/modal";


@NgModule({
  declarations: [
    MeasuringDevicesComponent,
    EditMeasuringDevicesComponent,
    ShowMeasuringDevicesComponent,
  ],
    imports: [
        CommonModule,
        RouterModule,
        NxCardModule,
        NxIconModule,
        ComponentsModule,
        NxHeadlineModule,
        NxGridModule,
        NxButtonModule,
        NxFormfieldModule,
        NxInputModule,
        FormsModule,
        NxSwitcherModule,
        NxDropdownModule,
        TextFieldModule,
        NxToolbarModule,
        NxImageModule,
        NxMessageModule,
        IrfComponentsModule,
        NxDatefieldModule,
        NxModalModule,
    ]
})
export class MeasuringDeviceModule {
}
